import React, { cloneElement, Children, Component } from 'react';
import styles from './Steps.scss'

export default class Steps extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const filteredChildren = Children.toArray(this.props.children).filter(c => !!c);

    return (
      <div className={styles.steps}>
        {
          Children.map(filteredChildren, (child, index) => {
            if (!child) {
              return null;
            }

            const childProps = {
              stepNumber: `${index + 1}`,
              success: (index + 1) < this.props.current,
              current: this.props.current === (index + 1),
              ...child.props,
            };

            return cloneElement(child, childProps);
          })
        }
      </div>
    );
  }
}
